import  Chatapp from '../assets/works/chatapp.png'
import  Films from '../assets/works/films.png'
import  Todoapp from '../assets/works/todoapp.png'
import  ReactTravel from '../assets/works/react-travel-website.png'
import  Weatherapp from '../assets/works/weatherapp.png'
import  Webstudio from '../assets/works/webstudio.png'

export const data=[
    {
        id:1,
        name:"React JS Application / ChatApp",
        image:Chatapp,
        github:"",
        live:"https://chat-app-tim-pop.netlify.app/",
    },
    {
        id:2,
        name:"React JS Application / FilmsApp",
        image:Films,
        github:"https://github.com/Tymur-Popov/goit-react-hw-05-movies",
        live:"https://tymur-popov.github.io/goit-react-hw-05-movies/",
    },
    {
        id:3,
        name:"React JS Application / TodoApp",
        image:Todoapp,
        github:"",
        live:"https://to-do-app-tim-pop.netlify.app/",
    },
    {
        id:4,
        name:"React JS Application / Travel Website",
        image:ReactTravel,
        github:"",
        live:"https://travel-react-web.netlify.app/",
    },
    {
        id:5,
        name:"React JS Application / Today-weather app",
        image:Weatherapp,
        github:"https://github.com/Tymur-Popov/react-weather-app",
        live:"https://tymur-popov.github.io/react-weather-app/",
    },
    {
        id:6,
        name:"Responsive website / Web-Studio",
        image:Webstudio,
        github:"https://github.com/Tymur-Popov/responsive-web-studio",
        live:"https://tymur-popov.github.io/responsive-web-studio/",
    },


]